module.exports = __webpack_public_path__ + "static/media/plane(27).81ebade4.PNG";